import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SuccessPopup({ open, handleClose, message, duration }) {
  React.useEffect(function () {
    setTimeout(
      () => {
        handleClose();
      },
      duration ? duration : 1000
    );
  }, []);
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "white",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            padding: 16,
            width: "343px",
            height: "185px",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <DialogContentText color="secondary">
            {message ? message : "Profile Updated Successful"}
          </DialogContentText>
          <DoneIcon
            sx={{
              width: "60px",
              height: "60px",
              backgroundColor: "#60E31A",
              padding: "16px",
              fontSize: "40px",
              borderRadius: "50%",
            }}
            color="default"
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
